import { chapterConfig, chapterSocials } from "@repo/vihangam-yog-shared";

const CHAPTER = chapterConfig("sg");
export const SOCIALS = chapterSocials("sg");

export interface NavItem {
  label: string;
  href: string;
  children?: { label: string; href: string; external?: boolean }[];
}

/** The nine items of the old site, same order, same dropdowns. */
export const NAV: NavItem[] = [
  { label: "Home", href: "/" },
  { label: "About", href: "/#about" },
  { label: "Inspiration", href: "/inspiration" },
  {
    label: "Resources",
    href: "/resources",
    children: [
      { label: "Audio & Video", href: "/resources/audio-video" },
      { label: "Slide Reading", href: "/resources/slide-reading" },
      { label: "Scientific Research", href: "/resources/scientific-research" },
      { label: "Magazine/Newsletter", href: "/resources/newsletter-magazine" },
      { label: "Prayer & Music", href: "/resources/prayer-music" },
      {
        label: "Divine Quotes",
        href: "https://www.instagram.com/naam.deo/?hl=en",
        external: true,
      },
    ],
  },
  {
    label: "Activities",
    href: "/activities",
    children: [
      { label: "Daily Practice", href: "/activities/daily-practice" },
      { label: "Weekly Session", href: "/activities/weekly-session" },
      {
        label: "Swarved 24-hr Recitation",
        href: "/activities/swarved-akhand-path",
      },
      { label: "Gita Jayanti 2021", href: "/activities/gita-jayanti-2021" },
    ],
  },
  {
    label: "Gallery",
    href: "/gallery",
    children: [
      {
        label: "Lifestyle Fair 2022 Aug",
        href: "/gallery/lifestyle-fair-2022",
      },
      {
        label: "Meet-Greet-Meditate-Share 2022 Jun",
        href: "/gallery/meet-greet-meditate-share-2022",
      },
      { label: "Old Photos", href: "/gallery/old-photos" },
    ],
  },
  {
    label: "Events",
    href: "/events",
    children: [
      { label: "Meditation Challenge", href: "/events/meditation-challenge" },
      { label: "IGF 2021", href: "/events/igf-2021" },
    ],
  },
  { label: "Swarved", href: "/swarved" },
  { label: "Calendar", href: "/calendar" },
  { label: "Contact", href: "/contact" },
];

export const PHONE = { display: "+65 9011 7690", tel: "tel:+6590117690" };
/** The other two numbers on the organisers' visit flyer; PHONE stays primary. */
export const MORE_PHONES = [
  { display: "9779 0814", tel: "tel:+6597790814" },
  { display: "9277 5007", tel: "tel:+6592775007" },
] as const;
export const WHATSAPP_URL = SOCIALS.whatsappUrl ?? "https://wa.me/6590117690";
export const EMAIL = CHAPTER.contactInbox;
export const OFFICE =
  "1 North Bridge Road, #18-07, High Street Centre, Singapore 179094";

/** The bar under the header. Replaces the old marquee iframe. */
export const ANNOUNCEMENT = {
  text: "Registration is open for Vihangam Yoga Religious Discourse, Prayer, Devotional Activities and Spiritual Meditation on Saturday 3 October and the 501-Kunds Hawan Yajna on Sunday 4 October 2026.",
  cta: "Register",
  href: "/register",
};

export const FOOTER = {
  title: "Awaken the dormant conscious power",
  body: "Meditation is a fundamental method of awakening consciousness. With regular practice it becomes refined and sharp.",
  link: {
    label: "Learn a unique technique to control your mind",
    href: "/activities/daily-practice",
  },
  quickLinks: [
    { label: "Activities", href: "/activities" },
    { label: "Daily Practice", href: "/activities/daily-practice" },
    { label: "Donate", href: "/donate" },
    { label: "Swarved", href: "/swarved" },
    { label: "Prayer & Music", href: "/resources/prayer-music" },
    { label: "Scientific Research", href: "/resources/scientific-research" },
    { label: "Slide Reading", href: "/resources/slide-reading" },
    { label: "Weekly Session", href: "/activities/weekly-session" },
  ],
  copyright: "Copyright 2026 Vihangam Yoga Singapore. All rights reserved.",
};
